"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utilities = exports["default"] = void 0;
var _viewport = _interopRequireDefault(require("../viewport"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var utilities = exports.utilities = {
  ucfirst: function ucfirst(string) {
    if (!utilities.isString(string)) {
      return null;
    }
    return string.charAt(0).toUpperCase() + string.substring(1);
  },
  clamp: function clamp(value, min, max) {
    // Return the value if it's between the min and max.
    // If it's outside the min and max range, return the side it's breached.
    return Math.min(Math.max(value, min), max);
  },
  getDataAttributes: function getDataAttributes(props) {
    //extract data attributes from props
    return _objectSpread({}, Object.keys(props).filter(function (key) {
      return key.indexOf("data-") === 0;
    }).reduce(function (obj, key) {
      obj[key] = props[key];
      return obj;
    }, {}));
  },
  isString: function isString(maybe) {
    return typeof maybe === "string";
  },
  cleanString: function cleanString(text) {
    if (!utilities.isString(text)) {
      return text;
    }
    return text
    // Handle curly quotes, long dash and ellipsis from word processors:
    .replace(/[\u2018-\u2019]/g, "'").replace(/[\u201C-\u201D]/g, '"').replace(/[\u2013-\u2014]/g, "-").replace(/\u2026/g, "...")
    // Remove Emoji chars
    .replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, "")
    // Then remove any remaining non-latin chars:
    .replace(/[\u0250-\ue007]/g, "");
  },
  immutableSort: function immutableSort(array, cmp) {
    return array.slice(0).sort(cmp);
  },
  decodeAscii: function decodeAscii(input) {
    return input.replace(/&#(\d+);/g, function (match, dec) {
      return String.fromCharCode(dec);
    });
  },
  getValueById: function getValueById(id, object) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (id < 1 || !object.data || !object.data.length) {
      return "";
    }
    var value = object.data.find(function (item) {
      return parseInt(item.id) === parseInt(id);
    });
    if (!value) {
      return "";
    }
    if (key) {
      return value[key];
    } else {
      return value;
    }
  },
  getUrlExtension: function getUrlExtension() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    url = url.substring(1 + url.lastIndexOf("/") || 0);
    if (!url.includes(".")) {
      return "";
    }
    return url.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
  },
  device: {
    viewport: new _viewport["default"](),
    IsDeviceIOS: function IsDeviceIOS() {
      return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      navigator.userAgent.includes("Mac") && "ontouchend" in document;
    },
    isMobileDevice: function isMobileDevice() {
      var clientWidth = utilities.device.viewport.getViewportWidth();
      var clientHeight = utilities.device.viewport.getViewportHeight();
      return Math.min(clientWidth, clientHeight) < 768;
    },
    isDesktopDevice: function isDesktopDevice() {
      return !utilities.device.isMobileDevice();
    }
  },
  currency: {
    getCurrencySymbol: function getCurrencySymbol(currency, placement) {
      return (currency === null || currency === void 0 ? void 0 : currency.symbol[placement]) || "";
    },
    formatCurrencyPrice: function formatCurrencyPrice(cost, currency) {
      return "".concat(utilities.decodeAscii(utilities.currency.getCurrencySymbol(currency, "left"))).concat(parseFloat(cost).toFixed(2)).concat(utilities.decodeAscii(utilities.currency.getCurrencySymbol(currency, "right")));
    }
  },
  array: {
    sortOneArrayByAnother: function sortOneArrayByAnother(arrayOne, arrayTwo) {
      var tempArray = _toConsumableArray(arrayTwo);
      var newArrayTwo = [];
      arrayOne.forEach(function (item) {
        var index = tempArray.indexOf(item);
        if (index >= 0) {
          newArrayTwo.push(item);
          tempArray[index] = null;
        }
      });
      tempArray = tempArray.filter(function (n) {
        return n;
      });
      return [].concat(newArrayTwo, _toConsumableArray(tempArray));
    },
    merge: function merge(arrayOne, arrayTwo, length) {
      var result = [];

      /* istanbul ignore else */
      if (arrayOne.length > 0) {
        arrayTwo = utilities.array.sortOneArrayByAnother(arrayOne, arrayTwo);
      }
      for (var i = 0; i < length; i++) {
        if (arrayOne[i] && arrayOne[i] !== arrayTwo[i]) {
          arrayTwo.splice(i, 0, 0);
        }

        /* istanbul ignore else */
        if (arrayOne[i]) {
          result.push(arrayOne[i]);
        } else if (arrayTwo[i]) {
          result.push(arrayTwo[i]);
        }
      }
      return result;
    }
  }
};
var _default = exports["default"] = utilities;